// Replicated from this location confluence/next/packages/content-smartlinks/src/smartLinkBatchHelpers.ts
const UNKNOWN = 'unknown';
export const smartLinkBatchHelpers = {};

export type SmartLinkType = {
	resourceUrl: string;
	title?: string | null;
};

export function getLinkType(link: string): string {
	if (
		link.includes('/jira/') ||
		link.includes('/servicedesk/') ||
		link.includes('/helpcenter/') ||
		link.includes('/projects/') ||
		link.includes('/browse/')
	) {
		return 'jira';
	}
	if (link.includes('/wiki/')) {
		return 'confluence';
	}
	if (link.includes('bitbucket')) {
		return 'bitbucket';
	}
	if (link.includes('atlassian') || link.includes('jira-dev')) {
		return 'otherAtlassian';
	}
	return 'thirdParty';
}

export function groupSmartLinksByHostname(smartLinks: SmartLinkType[]): SmartLinkType[][] {
	return Object.values(
		smartLinks.reduce(
			(acc, smartLink) => {
				try {
					const hostname = new URL(smartLink.resourceUrl).hostname;
					if (!acc[hostname]) {
						acc[hostname] = [];
					}
					acc[hostname].push(smartLink);
				} catch (e) {
					if (!acc[UNKNOWN]) {
						acc[UNKNOWN] = [];
					}
					acc[UNKNOWN].push(smartLink);
				}
				return acc;
			},
			// oxlint-disable-next-line typescript/consistent-type-assertions
			{} as Record<string, SmartLinkType[]>,
		),
	);
}

export function mergeSmallThirdPartyBatches(
	smartLinksGroups: SmartLinkType[][],
	min: number,
): SmartLinkType[][] {
	const result: SmartLinkType[][] = [];
	const smallThirdPartyBatches: SmartLinkType[] = [];
	for (const smartLinks of smartLinksGroups) {
		if (smartLinks.length >= min || getLinkType(smartLinks[0].resourceUrl) !== 'thirdParty') {
			result.push(smartLinks);
		} else {
			smallThirdPartyBatches.push(...smartLinks);
		}
	}
	if (smallThirdPartyBatches.length > 0) {
		result.push(smallThirdPartyBatches);
	}
	return result;
}

export function splitLinksIntoBatches(
	smartLinksGroups: SmartLinkType[][],
	max: number,
): SmartLinkType[][] {
	const result: SmartLinkType[][] = [];
	for (const smartLinks of smartLinksGroups) {
		if (smartLinks.length <= max) {
			result.push(smartLinks);
		} else {
			for (let i = 0; i < smartLinks.length; i += max) {
				result.push(smartLinks.slice(i, i + max));
			}
		}
	}
	return result;
}

export function isFirstPartyLink(resourceUrl: string): boolean {
	const type = getLinkType(resourceUrl);
	switch (type) {
		case 'jira':
		case 'confluence':
		case 'bitbucket':
		case 'otherAtlassian':
			return true;
		default:
			return false;
	}
}
